<div class="text-input multiple-email-input-container body {{size}}" #input [attr.contenteditable]="enabled"
    (keydown)="handleKeyDownEvent( $event )" (paste)="handlePasteEvent( $event )" [attr.data-placeholder]="placeholder"></div>